import React from 'react';
import propTypes from 'prop-types';
import { cn } from 'lib/utils';

/**
 * small green pill that flags a recently launched page or feature
 * @param label - text inside the pill, defaults to 'NEW'
 * @param className - extra classes for the pill
 */
export default function NewBadge({ label = 'NEW', className }) {
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center rounded-full bg-green-600 px-1.5 py-px text-[10px] font-semibold uppercase leading-4 tracking-wide text-white',
        className
      )}
    >
      {label}
    </span>
  );
}

NewBadge.propTypes = {
  label: propTypes.string,
  className: propTypes.string
};
